module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-active-bg.3b972020.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-active-bg.png
// module id = 3483
// module chunks = 11